__turbopack_context__.v({
  "wrap": "Notice-module-scss-module__lZxNJa__wrap",
});
